class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.section;
    const delay = parseInt(`${this.dataset.delay}000`);
    // 只有当 localStorage 没有 newsletter_shown 标记时显示弹窗
    if (!localStorage.getItem('newsletter_shown')) {
      setTimeout(() => {
        this.show();
      }, delay);
    }
  }
  
  show() {
    document.body.classList.add('modal-loading');
    this.classList.add('modal-open');
    this.close();
  }
  
  close() {
    // 绑定 ESC 键关闭事件
    window.onkeyup = (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.onButtonClick(event);
      }
    };
    
    // 绑定所有 data-modal-close 按钮点击事件
    this.querySelectorAll('[data-modal-close]').forEach((action) => {
      action.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    // 记录关闭状态，只记录一次
    if (!localStorage.getItem('newsletter_shown')) {
      localStorage.setItem('newsletter_shown', 'true');
    }
    document.body.classList.remove('modal-loading');
    this.classList.remove('modal-open');
    window.scrollTo(0, 0); // 关闭弹窗后滚动到页面顶部
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
